<template>
  <div class="container">
    <h1 class="topic-title">분야를 선택하세요</h1>
    <categoryitem
      v-for="(section, index) in sections"
      :key="index"
      :index="index"
      :section_name="section"
      :sectionStates="sectionStates[index]"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import categoryitem from './categoryItem'
/* eslint-disable */
export default {
  components: {
    categoryitem,
  },
  computed: {
    ...mapGetters(["sectionStates"]),
    ...mapState(["sections"]),
  }
};
</script>

<style>
.railroad img {
  padding-left: 4px;
  padding-right: 4px;
}
.resize img {
  width: 70%;
  margin: 15%;
}
</style>



// WEBPACK FOOTER //
// src/components/categoryList.vue